import { useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import {
  Banner,
  Box,
  Flex,
  Link,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@optiaxiom/react';
import { useDecision } from '@optimizely/react-sdk';

import { PageHeader } from '@frontend/components';
import { OPAL_SYSTEM_INSTRUCTION_MANAGER_FEATURE_FLAG } from '@frontend/envConfig';
import { AppPagePadding } from '@frontend/styles';

import { InstructionForm } from './InstructionForm';
import { InstructionListContent } from './InstructionListContent';

export function InstructionPage() {
  const [decision] = useDecision(OPAL_SYSTEM_INSTRUCTION_MANAGER_FEATURE_FLAG);
  const isSystemInstructionManager = decision.enabled;
  const location = useLocation();
  const initialActiveTab = location.pathname.includes('/system') ? 'system' : 'user';
  const [activeTab, setActiveTab] = useState<'user' | 'system'>(initialActiveTab);

  return (
    <Routes>
      <Route path="/create/system-instruction" element={<InstructionForm />} />
      <Route path="/create" element={<InstructionForm />} />
      <Route path="/edit/:id" element={<InstructionForm />} />
      <Route path="/edit/system-instruction/:id" element={<InstructionForm />} />
      <Route
        path="/*"
        element={
          <Flex flexDirection="column" gap="24" className={AppPagePadding}>
            <PageHeader
              title="Instructions"
              headingText={
                <>
                  Tailor Opal&apos;s output to your organization by providing specific context and
                  guidance.{' '}
                  <Link
                    external
                    href="https://support.optimizely.com/hc/en-us/sections/36381461176589-Instructions"
                  >
                    Learn more.
                  </Link>
                </>
              }
            />

            {isSystemInstructionManager ? (
              <Tabs
                value={activeTab}
                onValueChange={value => setActiveTab(value as 'user' | 'system')}
              >
                <TabsList>
                  <TabsTrigger value="user">User Instructions</TabsTrigger>
                  <TabsTrigger value="system">System Instructions</TabsTrigger>
                </TabsList>

                <TabsContent py="16" value="user">
                  <InstructionListContent instructionType="user" />
                </TabsContent>

                <TabsContent py="16" value="system">
                  <Box display="flex" flexDirection="column" gap="8">
                    <Banner intent="warning">
                      Modifying system instructions will affect all users.
                    </Banner>
                    <InstructionListContent instructionType="system" />
                  </Box>
                </TabsContent>
              </Tabs>
            ) : (
              <InstructionListContent instructionType="user" />
            )}
          </Flex>
        }
      />
    </Routes>
  );
}
